import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20fashion%20retail%20interior%20with%20warm%20amber%20and%20gold%20accent%20lighting%20reflecting%20off%20polished%20marble%20floors%2C%20elegant%20clothing%20displays%20on%20dark%20metal%20racks%2C%20sophisticated%20boutique%20atmosphere%20with%20depth%20and%20glamour%2C%20upscale%20editorial%20photography%20with%20rich%20tonal%20contrast%20and%20refined%20composition&width=1920&height=800&seq=cta-bg-v2-main-01&orientation=landscape"
          alt="Superbuy Spreadsheet shopping"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 tracking-wide">
          READY TO SHOP?
        </h2>
        <p className="text-lg md:text-xl text-white/80 font-light mb-10 leading-relaxed max-w-xl mx-auto">
          Get the best deals with our superbuy spreadsheet. Start exploring trusted sellers and curated categories today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-white rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center -ml-1">
              <i className="ri-shopping-bag-line text-white w-4 h-4 flex items-center justify-center"></i>
            </span>
            BUY IT NOW
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <Link
            to="/what-is-superbuy-spreadsheet/"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Learn More
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}